import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'app/common/link'
import { media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { TinyText } from 'app/common/typography'
import styled from 'styled-components'

export type BreadcrumbElement = {
    title: string,
    link?: string
}

type Props = {
    breadcrumbArray: Array<BreadcrumbElement>,
    color?: string
}

const renderBreadcrumb = (breadcrum: BreadcrumbElement, index: number) => {
    if (breadcrum.link) {
        return (
            <Link key={index} url={breadcrum.link}>
                {breadcrum.title}
            </Link>
        )
    } else {
        if (breadcrum.title) {
            return breadcrum.title
        } else return null
    }
}

const Breadcrumb = (props: Props) => {
    const { breadcrumbArray, color = colors.grey } = props

    return (
        <StyledTinyText color={color}>
            <Link url={'/'}>
                <FormattedMessage id="home.breadcrumb.start" />
            </Link>
            {breadcrumbArray.map((breadcrum, index) =>
                renderBreadcrumb(breadcrum, index)
            )}
        </StyledTinyText>
    )
}

const StyledTinyText = styled(TinyText)`
    margin-bottom: 10px;
    display: none;
    ${media.medium`
        display: inline-flex;
        width: 100%;
    `};
`

export { Breadcrumb }
